import script from "./preBook.vue?vue&type=script&setup=true&lang=js"
export * from "./preBook.vue?vue&type=script&setup=true&lang=js"

import "./preBook.vue?vue&type=style&index=0&id=6e526094&lang=scss"

const __exports__ = script;

export default __exports__